import React from 'react';
import FontAwesome from 'react-fontawesome';

class CollapsiblePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: false
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({
            collapse: !this.state.collapse
        })
    }

    render () {

        let headingClass = "cursor-p panel-heading";
        headingClass += (this.state.collapse ? " collapsed" : "");

        let contentClass = "panel-collapse collapse";
        contentClass += (this.state.collapse ? " in" : "");

        return (
            <div className="panel">
                <a className={headingClass} role="tab" onClick={this.handleToggle}>
                    <h4 className="panel-title">
                        {this.state.collapse && <FontAwesome name="caret-down"/>}
                        {!this.state.collapse && <FontAwesome name="caret-right"/>}
                        &nbsp;&nbsp;&nbsp;
                        {this.props.heading}
                        </h4>
                </a>
                <div className={contentClass} role="tabpanel">
                    <div className="panel-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default CollapsiblePanel;


/** WEBPACK FOOTER **
 ** ./src/components/Accordion/CollapsiblePanel.js
 **/